/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1AuthExchangeRequest
 */
export interface V1AuthExchangeRequest {
    /**
     *
     */
    initData: string
}

/**
 * Check if a given object implements the V1AuthExchangeRequest interface.
 */
export function instanceOfV1AuthExchangeRequest(
    value: object
): value is V1AuthExchangeRequest {
    if (!('initData' in value) || value['initData'] === undefined) return false
    return true
}

export function V1AuthExchangeRequestFromJSON(
    json: any
): V1AuthExchangeRequest {
    return V1AuthExchangeRequestFromJSONTyped(json, false)
}

export function V1AuthExchangeRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthExchangeRequest {
    if (json == null) {
        return json
    }
    return {
        initData: json['initData']
    }
}

export function V1AuthExchangeRequestToJSON(json: any): V1AuthExchangeRequest {
    return V1AuthExchangeRequestToJSONTyped(json, false)
}

export function V1AuthExchangeRequestToJSONTyped(
    value?: V1AuthExchangeRequest | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        initData: value['initData']
    }
}
